module.exports = __webpack_public_path__ + "static/media/1_RoomControls_Temperature_HL.df096a0d.png";